import {
  Email,
  FirstName,
  LastName,
  USAStateAcronym,
  UsPhone,
  ZipCode,
} from '@hc-frontend/core-types';
import type { ZodFormattedError } from 'zod';
import { z } from 'zod';

export enum FieldNames {
  CASE_TYPE = 'case_type',
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  ZIP_CODE = 'zip_code',
  PHONE_NUMBER = 'phone_number',
  STATE = 'state',
}

export const UserInputs = z.object({
  [FieldNames.CASE_TYPE]: z.enum([
    'ccpa-delete-req',
    'ccpa-info-req',
    'ccpa-opt-out-sales-req',
  ]),
  [FieldNames.FIRST_NAME]: FirstName,
  [FieldNames.LAST_NAME]: LastName,
  [FieldNames.EMAIL]: Email,
  [FieldNames.PHONE_NUMBER]: UsPhone,
  [FieldNames.ZIP_CODE]: ZipCode,
});

export type UserInputs = z.infer<typeof UserInputs>;

export const FormFields = UserInputs.merge(
  z.object({
    [FieldNames.STATE]: USAStateAcronym,
  }),
);

export type FormFields = z.infer<typeof FormFields>;
export type FormState = ZodFormattedError<FormFields>;
